import axios from 'axios'
import { BASE_PATH_PORTAL } from '../../constants'

export const getConfig = async () => {
  const response = await axios.get(`${BASE_PATH_PORTAL}/api/v1/config`)
  return response.data
}
